// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Vision & Mission Page - Rich Text Content Styles */

/* Make sure HTML from Rich Text Editor renders properly */
.vision-content p,
.mission-content p,
.core-value-content p {
  margin-bottom: 1em;
}

.vision-content strong,
.mission-content strong,
.core-value-content strong {
  font-weight: bold !important;
}

.vision-content em,
.mission-content em,
.core-value-content em {
  font-style: italic !important;
}

.vision-content u,
.mission-content u,
.core-value-content u {
  text-decoration: underline !important;
}

.vision-content h1,
.mission-content h1,
.core-value-content h1 {
  font-size: 2em !important;
  font-weight: bold !important;
  margin-bottom: 0.5em !important;
}

.vision-content h2,
.mission-content h2,
.core-value-content h2 {
  font-size: 1.5em !important;
  font-weight: bold !important;
  margin-bottom: 0.5em !important;
}

.vision-content h3,
.mission-content h3,
.core-value-content h3 {
  font-size: 1.25em !important;
  font-weight: bold !important;
  margin-bottom: 0.5em !important;
}

.vision-content ul,
.mission-content ul,
.core-value-content ul {
  list-style-type: disc !important;
  padding-left: 2em !important;
  margin-bottom: 1em !important;
}

.vision-content ol,
.mission-content ol,
.core-value-content ol {
  list-style-type: decimal !important;
  padding-left: 2em !important;
  margin-bottom: 1em !important;
}

.vision-content li,
.mission-content li,
.core-value-content li {
  margin-bottom: 0.5em !important;
}

.vision-content blockquote,
.mission-content blockquote,
.core-value-content blockquote {
  border-left: 4px solid #dc2626 !important;
  padding-left: 16px !important;
  margin-left: 0 !important;
  color: #6b7280 !important;
  font-style: italic !important;
  margin-bottom: 1em !important;
}

.vision-content a,
.mission-content a,
.core-value-content a {
  color: #2563eb !important;
  text-decoration: underline !important;
}

.vision-content img,
.mission-content img,
.core-value-content img {
  max-width: 100% !important;
  height: auto !important;
  margin-bottom: 1em !important;
}

.vision-content pre,
.mission-content pre,
.core-value-content pre {
  background-color: #f3f4f6 !important;
  padding: 12px !important;
  border-radius: 4px !important;
  overflow-x: auto !important;
  margin-bottom: 1em !important;
  font-family: monospace !important;
}

.vision-content code,
.mission-content code,
.core-value-content code {
  background-color: #f3f4f6 !important;
  padding: 2px 6px !important;
  border-radius: 3px !important;
  font-family: monospace !important;
}

/* Text alignment classes from Quill */
.vision-content .ql-align-center,
.mission-content .ql-align-center,
.core-value-content .ql-align-center {
  text-align: center !important;
}

.vision-content .ql-align-right,
.mission-content .ql-align-right,
.core-value-content .ql-align-right {
  text-align: right !important;
}

.vision-content .ql-align-justify,
.mission-content .ql-align-justify,
.core-value-content .ql-align-justify {
  text-align: justify !important;
}

/* Font sizes from Quill */
.vision-content .ql-size-small,
.mission-content .ql-size-small,
.core-value-content .ql-size-small {
  font-size: 0.75em !important;
}

.vision-content .ql-size-large,
.mission-content .ql-size-large,
.core-value-content .ql-size-large {
  font-size: 1.5em !important;
}

.vision-content .ql-size-huge,
.mission-content .ql-size-huge,
.core-value-content .ql-size-huge {
  font-size: 2.5em !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/VisionMissionPage.css"],"names":[],"mappings":"AAAA,qDAAqD;;AAErD,0DAA0D;AAC1D;;;EAGE,kBAAkB;AACpB;;AAEA;;;EAGE,4BAA4B;AAC9B;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA;;;EAGE,qCAAqC;AACvC;;AAEA;;;EAGE,yBAAyB;EACzB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;;;EAGE,2BAA2B;EAC3B,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;;;EAGE,4BAA4B;EAC5B,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;;;EAGE,gCAAgC;EAChC,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;;;EAGE,mCAAmC;EACnC,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;;;EAGE,+BAA+B;AACjC;;AAEA;;;EAGE,yCAAyC;EACzC,6BAA6B;EAC7B,yBAAyB;EACzB,yBAAyB;EACzB,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;;;EAGE,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;;;EAGE,0BAA0B;EAC1B,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;;;EAGE,oCAAoC;EACpC,wBAAwB;EACxB,6BAA6B;EAC7B,2BAA2B;EAC3B,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;;;EAGE,oCAAoC;EACpC,2BAA2B;EAC3B,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA,sCAAsC;AACtC;;;EAGE,6BAA6B;AAC/B;;AAEA;;;EAGE,4BAA4B;AAC9B;;AAEA;;;EAGE,8BAA8B;AAChC;;AAEA,0BAA0B;AAC1B;;;EAGE,4BAA4B;AAC9B;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;;;EAGE,2BAA2B;AAC7B","sourcesContent":["/* Vision & Mission Page - Rich Text Content Styles */\n\n/* Make sure HTML from Rich Text Editor renders properly */\n.vision-content p,\n.mission-content p,\n.core-value-content p {\n  margin-bottom: 1em;\n}\n\n.vision-content strong,\n.mission-content strong,\n.core-value-content strong {\n  font-weight: bold !important;\n}\n\n.vision-content em,\n.mission-content em,\n.core-value-content em {\n  font-style: italic !important;\n}\n\n.vision-content u,\n.mission-content u,\n.core-value-content u {\n  text-decoration: underline !important;\n}\n\n.vision-content h1,\n.mission-content h1,\n.core-value-content h1 {\n  font-size: 2em !important;\n  font-weight: bold !important;\n  margin-bottom: 0.5em !important;\n}\n\n.vision-content h2,\n.mission-content h2,\n.core-value-content h2 {\n  font-size: 1.5em !important;\n  font-weight: bold !important;\n  margin-bottom: 0.5em !important;\n}\n\n.vision-content h3,\n.mission-content h3,\n.core-value-content h3 {\n  font-size: 1.25em !important;\n  font-weight: bold !important;\n  margin-bottom: 0.5em !important;\n}\n\n.vision-content ul,\n.mission-content ul,\n.core-value-content ul {\n  list-style-type: disc !important;\n  padding-left: 2em !important;\n  margin-bottom: 1em !important;\n}\n\n.vision-content ol,\n.mission-content ol,\n.core-value-content ol {\n  list-style-type: decimal !important;\n  padding-left: 2em !important;\n  margin-bottom: 1em !important;\n}\n\n.vision-content li,\n.mission-content li,\n.core-value-content li {\n  margin-bottom: 0.5em !important;\n}\n\n.vision-content blockquote,\n.mission-content blockquote,\n.core-value-content blockquote {\n  border-left: 4px solid #dc2626 !important;\n  padding-left: 16px !important;\n  margin-left: 0 !important;\n  color: #6b7280 !important;\n  font-style: italic !important;\n  margin-bottom: 1em !important;\n}\n\n.vision-content a,\n.mission-content a,\n.core-value-content a {\n  color: #2563eb !important;\n  text-decoration: underline !important;\n}\n\n.vision-content img,\n.mission-content img,\n.core-value-content img {\n  max-width: 100% !important;\n  height: auto !important;\n  margin-bottom: 1em !important;\n}\n\n.vision-content pre,\n.mission-content pre,\n.core-value-content pre {\n  background-color: #f3f4f6 !important;\n  padding: 12px !important;\n  border-radius: 4px !important;\n  overflow-x: auto !important;\n  margin-bottom: 1em !important;\n  font-family: monospace !important;\n}\n\n.vision-content code,\n.mission-content code,\n.core-value-content code {\n  background-color: #f3f4f6 !important;\n  padding: 2px 6px !important;\n  border-radius: 3px !important;\n  font-family: monospace !important;\n}\n\n/* Text alignment classes from Quill */\n.vision-content .ql-align-center,\n.mission-content .ql-align-center,\n.core-value-content .ql-align-center {\n  text-align: center !important;\n}\n\n.vision-content .ql-align-right,\n.mission-content .ql-align-right,\n.core-value-content .ql-align-right {\n  text-align: right !important;\n}\n\n.vision-content .ql-align-justify,\n.mission-content .ql-align-justify,\n.core-value-content .ql-align-justify {\n  text-align: justify !important;\n}\n\n/* Font sizes from Quill */\n.vision-content .ql-size-small,\n.mission-content .ql-size-small,\n.core-value-content .ql-size-small {\n  font-size: 0.75em !important;\n}\n\n.vision-content .ql-size-large,\n.mission-content .ql-size-large,\n.core-value-content .ql-size-large {\n  font-size: 1.5em !important;\n}\n\n.vision-content .ql-size-huge,\n.mission-content .ql-size-huge,\n.core-value-content .ql-size-huge {\n  font-size: 2.5em !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
